import { CSSProperties } from 'react';

export interface HomeCarouselStyles {
  skeleton: CSSProperties;
  wrapper: CSSProperties;
}

const styles: HomeCarouselStyles = {
  skeleton: {
    aspectRatio: '4 / 1',
    backgroundColor: '#eef2f6',
  },
  wrapper: {
    width: '100%',
  },
};

export default styles;
